import axios from "./axiosInstance";
import { Globals } from "../global/Globals";

export const registration=async( body)=>{
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.REGISTRATION;
    const config = {
        headers: {
          'Content-Type': 'multipart/form-data'//'application/json' // Set the Content-Type header
        }
      };
    const apiResponse = await axios.post(Globals.ENDPOINT.REGISTRATION,body,config);
    console.log("POST API ",apiResponse);
    return apiResponse;
}